import React, { useState } from "react"
import { FaPlus } from "react-icons/fa"
import Img from "gatsby-image"

import Link from "../../utils/link"

const Collapse = (props) => {
  const [x, setX] = useState(0)
  const [active, setActive] = useState("")

  const toggle = () => {
    x === 0 ? setX(45) : setX(0)
    active === "" ? setActive("active") : setActive("")
  }

  return (
    <>
      <div className="collapse-section__container__collapse__image">
        <Img
          fluid={props.image.localFile.childImageSharp.fluid}
          alt={props.image.altText}
        />
      </div>
      <div className="collapse-section__container__collapse__container">
        <div className="collapse-section__container__collapse__container__text">
          {props.title}
          <div
            className={`collapse-section__container__collapse__container__sub-text ${active}`}
          >
            {props.content}
            <div>
              <Link to={props.button.link}>{props.button.text}</Link>
            </div>
          </div>
        </div>
        <div className="collapse-section__container__collapse__container__toggler">
          <button onClick={toggle} style={{ transform: `rotate(${x}deg)` }}>
            <FaPlus />
          </button>
        </div>
      </div>
    </>
  )
}

export default Collapse
